import { API_ENDPOINTS } from "@features/creation/config/constants";
import UniversCommercialForm from "@features/creation/univers-commerciaux/components/UniversCommercialForm";
import api from "@lib/api";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Layers } from "lucide-react";

export const Route = createFileRoute("/_app/creation/univers-commerciaux/$id/edit")({
  loader: async (ctx) => {
    await requirePermission(PERMISSIONS.CREATION.UNIVERS_COMMERCIAUX.EDIT)(ctx);
    const { data } = await api.get(API_ENDPOINTS.UNIVERS_COMMERCIAUX.DETAIL(ctx.params.id));
    return data;
  },
  staticData: {
    title: "Modifier univers",
    icon: Layers,
    permission: PERMISSIONS.CREATION.UNIVERS_COMMERCIAUX.EDIT,
    section: "Creation",
    order: 15,
    showInBreadcrumb: true,
  },
  component: EditUniversCommercialPage,
});

function EditUniversCommercialPage() {
  const universCommercial = Route.useLoaderData();

  return (
    <div className="max-w-3xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Modifier l'univers commercial</h1>
        <p className="text-sm text-base-content/60">Modifier les détails de l'univers commercial</p>
      </div>
      <UniversCommercialForm universCommercial={universCommercial} />
    </div>
  );
}
